import React from "react"
import loadable from "@loadable/component"
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook"
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter"
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin"
import { FaQuora } from "@react-icons/all-files/fa/FaQuora"
import { FaReddit } from "@react-icons/all-files/fa/FaReddit"
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube"
import styled from "styled-components"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import BringtoTop from "./externals/bring-to-top"

const StyledFooter = styled.footer`
  color: #fff !important;

  h5 {
    color: #f4f3ef !important;
    font-weight: bold;
  }

  .chromeExtensionHead {
    color: #ffffff !important;
    font-size: 16px !important;
    font-weight: 700;
  }

  .chrome-extension-container {
    padding: 0 12px !important;
  }

  .ext-desc {
    font-size: 15px;
    line-height: 20px;
    color: #ffffffcf !important;
  }

  ul {
    padding: 0px;
    list-style-type: none;
    color: #fff !important;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0.2px;
  }

  ul > li > * {
    color: #ffffffcf;
  }

  .social-links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }

  .copy-text * {
    font-size: 14px;
    color: #fff !important;
  }

  ul > li > a:hover {
    color: #ffa700 !important;
  }

  .footer-container {
    background-color: #334a4a !important;
    border: 0px;
    padding: 0px 10px 0 20px;
  }

  .custom-shape-divider-top-1678271492 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 32px;
  }

  .custom-shape-divider-top-1678271492 .shape-fill {
    fill: #fff;
  }

  span {
    font-family: "Inter", sans-serif;
  }

  div {
    font-size: 14px !important;
  }

  .chrom-ext-btn {
    display: flex;
    align-items: center;
    width: 260px;
    height: 43px;
    font-size: 16px;
    color: #ffffff !important;
    border: 1px solid #ffffff;
    border-radius: 40px;
    margin-top: 10px;
    justify-content: center;
  }

  .chrom-ext-btn:hover {
    color: #4a4560 !important;
    border: 1px solid #ffffff;
    background-color: #ffffff;
  }

  .chrom-ext-btn svg {
    padding-right: 6px;
  }

  @media only screen and (min-width: 450px) {
    .col-ft-md {
      flex: 1 0 !important;
    }
  }

  @media only screen and (max-width: 295px) {
    .crm-txt {
      display: none;
    }
  }

  @media only screen and (max-width: 767px) {
    overflow-x: hidden; /* hide horizontal scrollbar */
    overflow-y: auto; /* show vertical scrollbar if needed */
    .sm-btm-space {
      margin-bottom: 15px !important;
    }
    .footer-container .col-md-6 .container {
      padding: 0 !important;
    }
    .mobileviewfix {
      flex-direction: column !important;
    }
    .lasttwogrid {
      flex-direction: column !important;
    }
  }
`

const LoadableFreshchat = loadable(() => import("./externals/freshchat"))
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const lastWeekDate = new Date(currentYear, 11, 25); // Assuming the last week starts on December 25th

// Check if the current date is within the last week
const isLastWeek = currentDate >= lastWeekDate && currentDate <= new Date(currentYear, 11, 31);

// Calculate the year to display based on the condition
const displayYear = isLastWeek ? currentYear + 1 : currentYear;

const Footer = ({ siteTitle }) => (
  <StyledFooter className="page-footer">
    <section style={{ position: "relative" }}>
      <div className="container-fluid footer-container text-left pt-3">
        <div className="container">
          <div className="row gx-5 pt-3 mobileviewfix">
            <div className="col col-md-2 ">
              <span className="fs-6 fw-bold">Company</span>
              <ul className="pt-2">
                <li>
                  <a href="/why-clearout/">Why Clearout?</a>
                </li>
                <li>
                  <a href="/pricing">Pricing</a>
                </li>
                <li>
                  <a href="/contact-us/">Contact Us</a>
                </li>
                <li>
                  <a href="/careers">Careers</a>
                </li>
                <li>
                  <a href="/email-validation-service-for-enterprise/">
                    Enterprise
                  </a>
                </li>
                <li>
                  <a href="/sitemap.xml">Sitemap</a>
                </li>
                <li>
                  <Link to="/faqs">FAQ</Link>
                </li>
                <li>
                  <a
                    href="https://status.clearout.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Status
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-md-2 ">
              <span className="fs-6 fw-bold">Products</span>
              <ul className="pt-2">
                <li>
                  <Link to="/email-verifier">Email Verifier</Link>
                </li>
                <li>
                  <Link to="/email-finder">Email Finder</Link>
                </li>
                <li>
                  <Link to="/sales-prospecting">Prospect</Link>
                </li>
                <li>
                  <Link to="/sales-prospecting/chrome-extension/">
                    LinkedIn Email Finder
                  </Link>
                </li>
                <li>
                  <Link to="/reverse-lookup/">
                    Reverse Lookup
                  </Link>
                </li>
                <li>
                  <a href="/integrations/clearout-for-sheets/">
                    Google Sheets Add-on
                  </a>
                </li>
                <li>
                  <a href="/integrations/wordpress/">WordPress Plugin</a>
                </li>
                <li>
                  <a
                    href="https://clearoutphone.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ClearoutPhone
                  </a>
                </li>
                <li>
                  <a
                    href="https://changelog.clearout.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    What's New?
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-md-2 ">
              <span className="fs-6 fw-bold">Resources</span>
              <ul className="pt-2">
                <li>
                  <a href="/integrations/">Integrations</a>
                </li>
                <li>
                  <a href="/integrations/hubspot/">HubSpot</a>
                </li>
                <li>
                  <a href="/team-account/">Team Account</a>
                </li>
                <li>
                  <Link to="/email-verification-api">
                    API
                  </Link>
                </li>
                <li>
                  <Link to="/compare-email-verifier">
                    Compare Email Verifier
                  </Link>
                </li>
                <li>
                  <Link to="/compare-prospecting-tools">
                    Compare Prospecting
                  </Link>
                </li>
                <li>
                  <Link to="/use-cases/lead-generation-solution/">
                    Use Cases
                  </Link>
                </li>
                <li>
                  <a href="/blog/">Blog</a>
                </li>
                <li>
                  <a href="/help/">Help</a>
                </li>
              </ul>
            </div>
            <div className="col col-md-2">
              <span className="fs-6 fw-bold">Legal</span>
              <ul className="pt-2">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <a href="/terms-condition">Terms</a>
                </li>
                <li>
                  <a href="/clearout-data-processing-agreement/">DPA</a>
                </li>
                <li>
                  <a href="/security-compliance/">Security</a>
                </li>                
                <li>
                  <a href="https://trust.clearout.io/" target="_blank" rel="noreferrer">Trust Center</a>
                </li>
              </ul>
            </div>
            <div className="col col-md-4 chrome-extension-container">
              <div className="container">
                <div className="row lasttwogrid">
                  <div className="col col-md-6">
                    <span className="fs-6 fw-bold">Certification</span>
                    <ul>
                      <li className="pt-2">
                        <a href="/security-compliance/">ISO 27001:2022</a>
                      </li>
                      <li>
                        <a href="/security-compliance/">SOC 2 Type II</a>
                      </li>
                      <li>
                        <a href="/gdpr/">GDPR</a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-ft-md col-md-6">
                    <span className="fs-6 fw-bold">Partnership</span>
                    <ul className="pt-2">
                      <li>
                        <a
                          href="/certified-app-in-hubspot-app-marketplace/"
                          aria-label="HubSpot Certified"
                        >
                          HubSpot Certified
                        </a>
                      </li>
                      <li>
                        <a href="/affiliates/">Affiliates</a>
                      </li>
                      <li>
                        <a href="/partners/">Partners</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 three-col">
                    <span className="chromeExtensionHead ">
                      Clearout for browser
                    </span>
                    <p className="ext-desc mt-2">
                      ⚡ Supercharge Your Prospect Research with Clearout's
                      LinkedIn Chrome Extension - Find and Verify Emails with
                      Confidence!
                    </p>
                    <a
                      className="chrom-ext-btn"
                      target="_blank"
                      href="https://chrome.google.com/webstore/detail/clearout-free-b2b-email-a/hjhpmemgiecpogjpmofnnaghdokkfcpp?utm_source=website&utm_medium=footer"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 48 48"
                        id="chrome"
                      >
                        <g fill="none" fillRule="evenodd">
                          <g transform="translate(-400 -1043)">
                            <g transform="translate(400 1043)">
                              <path
                                fill="#EA4335"
                                d="M5.795 8.361C16.952-4.624 37.64-2.06 45.373 13.107c-5.444.002-13.969-.001-18.586 0-3.349.001-5.51-.075-7.852 1.158-2.753 1.449-4.83 4.135-5.555 7.29L5.795 8.36z"
                              ></path>
                              <path
                                fill="#4285F4"
                                d="M16.015 24c0 4.4 3.579 7.98 7.977 7.98s7.976-3.58 7.976-7.98c0-4.401-3.578-7.982-7.976-7.982s-7.977 3.58-7.977 7.981z"
                              ></path>
                              <path
                                fill="#34A853"
                                d="M27.088 34.446c-4.477 1.33-9.717-.145-12.587-5.1A7917.733 7917.733 0 0 1 3.892 10.898C-5.322 25.02 2.62 44.264 19.346 47.55l7.742-13.103z"
                              ></path>
                              <path
                                fill="#FBBC05"
                                d="M31.401 16.018c3.73 3.468 4.542 9.084 2.016 13.439-1.903 3.28-7.977 13.531-10.92 18.495C39.73 49.015 52.294 32.124 46.62 16.018H31.4z"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span className="crm-txt">Clearout&nbsp;</span>Chrome
                      extension
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="gx-0 mx-0" />
          <div className="row gx-5 pb-3">
            <div className="col-md-3 sm-btm-space">
              <StaticImage
                src="../images/clearout-new-logo-white114.png"
                alt="clearout logo"
                width={150}
                height={26}
                placeholder="blurred"
              />
            </div>
            <div className="col-md-6 sm-btm-space">
              © {displayYear} Clearout. All Rights Reserved. Powered by Clearout LLC
            </div>
            <div className="social-links col-md-3 sm-btm-space">
              <a
                href="https://www.facebook.com/clearout.io/"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
                title="Clearout on Facebook"
              >
                <FaFacebook size={18} fill="#c7c3c3" />
              </a>
              <a
                href="https://twitter.com/ClearoutIo"
                aria-label="Twitter"
                target="_blank"
                rel="noreferrer"
                title="Clearout on Twitter"
              >
                <FaTwitter size={18} fill="#c7c3c3" />
              </a>
              <a
                href="https://www.linkedin.com/company/clearout-io"
                aria-label="LinkedIn"
                target="_blank"
                rel="noreferrer"
                title="Clearout on LinkedIn"
              >
                <FaLinkedin size={18} fill="#c7c3c3" />
              </a>
              <a
                href="https://www.quora.com/profile/Clearout"
                aria-label="Quora"
                target="_blank"
                rel="noreferrer"
                title="Clearout on Quora"
              >
                <FaQuora size={18} fill="#c7c3c3" />
              </a>
              <a
                href="https://www.reddit.com/user/clearout_io/"
                aria-label="Reddit"
                target="_blank"
                rel="noreferrer"
                title="Clearout on Reddit"
              >
                <FaReddit size={18} fill="#c7c3c3" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCq5yYOL1LBmUnAQdRAuVMPA"
                aria-label="YouTube"
                target="_blank"
                rel="noreferrer"
                title="Clearout on YouTube"
              >
                <FaYoutube size={18} fill="#c7c3c3" />
              </a>
            </div>
          </div>
        </div>
        <LoadableFreshchat />
        <div className="bringToTopContainer">
          <BringtoTop />
        </div>
      </div>
    </section>
  </StyledFooter>
)

export default Footer
